import { IDeThi_CauHoi } from "./../../action-types/de-thi/IDeThiActions";
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { deThiApi } from "../../../api/de-thi/deThiApi";
import { ISMT_DeThi_Request } from "../../../model/request/de-thi/ISMT_DeThi_Request";
import { ISMT_DeThi } from "../../../model/respone/de-thi/ISMT_DeThi";
import { ISMT_DeThi_Sub_Vm } from "../../../model/respone/de-thi/ISMT_DeThi_Sub";
import { ISMT_DeThi_Vm } from "../../../model/respone/de-thi/ISMT_DeThi_Vm";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDeThiActionIds,
  IDeThiActionTypes,
} from "../../action-types/de-thi/IDeThiActions";
import { rootActions } from "../../actions/rootActions";
import { ISMT_XemDeThi } from "../../../model/respone/de-thi/ISMT_XemDeThi";
import { xemDeThiApi } from "../../../api/de-thi/xemDeThiApi";
import { IDeThiProgressRequest } from "../../../model/request/de-thi/IDeThiProgressRequest";
import { ITongHopTheoDotRequest } from "../../../model/request/de-thi/ITongHopTheoDotRequest";
import { Download } from "../../../helpers/download";

export function* deThiSaga(): any {
  yield takeLatest(eDeThiActionIds.LOAD_START, loadWorker);
  yield takeLatest(eDeThiActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eDeThiActionIds.SAVE_START, saveWorker);
  yield takeLatest(eDeThiActionIds.DELETE_MULTIPLE_START, deleteMultipleWorker);
  yield takeLatest(eDeThiActionIds.LOAD_CHITIET_START, loadDetailWorker);
  yield takeLatest(eDeThiActionIds.PROGRESS_START, progressWorker);
  yield takeLatest(eDeThiActionIds.CHANGE_QUESTION_START, changQuestionWorker);
  yield takeLatest(eDeThiActionIds.VIEW_EXAM_START, viewExamWorker);
  yield takeLatest(eDeThiActionIds.PRINT_EXAM_START, printExamWorker);
  yield takeLatest(eDeThiActionIds.LOAD_TONGHOP_START, loadTongHopWorker);
  yield takeLatest(eDeThiActionIds.EXPORT_TONGHOP_START, exportTongHopWorker);
}

function* loadWorker(action: IDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiApi.Select,
    action.payload as ISMT_DeThi_Request
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThi.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.deThi.deThi.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* loadTongHopWorker(action: IDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiApi.TongHopTheoDot,
    action.payload as ITongHopTheoDotRequest
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThi.LOAD_TONGHOP_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.deThi.LOAD_TONGHOP_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IDeThiActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as ISMT_DeThi;
  if (payload.id > 0) {
    res = yield call(deThiApi.Update, payload);
  } else {
    res = yield call(deThiApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.deThi.deThi.SAVE_SUCCESS(res.data));
    } else {
      yield put(rootActions.deThi.deThi.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
  }
}

function* deleteWorker(action: IDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThi.DELETE_SUCCESS(res.data));
  } else {
    yield put(rootActions.deThi.deThi.DELETE_ERROR(res.message ?? "Có lỗi"));
  }
}
function* deleteMultipleWorker(action: IDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiApi.DeleteMultiple,
    action.payload as number[]
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThi.DELETE_MULTIPLE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.deThi.deThi.DELETE_MULTIPLE_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* loadDetailWorker(action: IDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiApi.SelectQuestionAnswer,
    action.payload as number
  );
  if (res.is_success) {
    yield put(
      rootActions.deThi.deThi.LOAD_CHITIET_SUCCESS(
        res.data.map((g: ISMT_DeThi_Sub_Vm) => {
          return {
            id_dethi: action.payload,
            data: g,
            data_change: {} as ISMT_DeThi_Sub_Vm,
          } as IDeThi_CauHoi;
        })
      )
    );
  } else {
    yield put(
      rootActions.deThi.deThi.LOAD_CHITIET_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* progressWorker(action: IDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiApi.Progress,
    action.payload as IDeThiProgressRequest
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThi.PROGRESS_SUCCESS(undefined));
  } else {
    yield put(rootActions.deThi.deThi.PROGRESS_ERROR(res.message ?? "Có lỗi"));
  }
}

function* changQuestionWorker(action: IDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiApi.ChangeQuestion,
    action.payload as ISMT_DeThi_Vm
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThi.CHANGE_QUESTION_SUCCESS(undefined));
  } else {
    yield put(
      rootActions.deThi.deThi.CHANGE_QUESTION_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* viewExamWorker(action: IDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    xemDeThiApi.Select,
    action.payload as ISMT_XemDeThi
  );
  if (res.is_success) {
    yield put(rootActions.deThi.deThi.VIEW_EXAM_SUCCESS(res.data));
  } else {
    yield put(rootActions.deThi.deThi.VIEW_EXAM_ERROR(res.message ?? "Có lỗi"));
  }
}

function* printExamWorker(): any {
  const examHtmlContent = yield select(
    (state) => state.deThi.deThi.examHtmlContent
  );

  if (examHtmlContent) {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    iframe.contentDocument!.open();
    iframe.contentDocument!.write(examHtmlContent);
    iframe.contentDocument!.close();
    iframe.contentWindow!.focus();
    iframe.contentWindow!.print();
    document.body.removeChild(iframe);
    yield put(rootActions.deThi.deThi.PRINT_EXAM_SUCCESS(undefined));
  }
}

function* exportTongHopWorker(action: IDeThiActionTypes): any {
  const res: IBaseRespone = yield call(
    deThiApi.ExportTongHop,
    action.payload as ITongHopTheoDotRequest
  );
  if (res.is_success) {
    Download.Excel(res.data, "tong_hop_de_thi.xlsx");
    yield put(rootActions.deThi.deThi.EXPORT_TONGHOP_SUCCESS(undefined));
  } else {
    yield put(
      rootActions.deThi.deThi.EXPORT_TONGHOP_ERRR(res.message ?? "Thất bại")
    );
  }
}
